import { useQuery } from 'react-query';

import { getBsTraps } from 'api/traps/BsTraps/getBsTraps';
import { TrapTableType } from 'components/TrapsTables/trapTables';

export const useGetBsTraps = (slug: string, page: number, search?: string, ordering?: string) => {
  const { data, refetch, isLoading } = useQuery(
    TrapTableType.BaitStations,
    () => getBsTraps(slug, page, search, ordering),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading };
};

export default useGetBsTraps;
